interface IProps {
  heading: string;
  desc: string;
  heading_image: any;
}

const EventHeader = ({ heading, desc, heading_image }: IProps) => {
  return (
    <div className=" py-8 flex flex-col md:flex-row gap-4 border-t border-border-stone">
      <div className="flex flex-col w-[100%] gap-6">
        <h2 className="font-medium text-5xl -ml-[0.05em]">{heading}</h2>
        <div className="text-base font-normal">{desc}</div>
      </div>
      {
        heading_image ? (
          <img
            src={
              heading_image
                ? process.env.REACT_APP_API_BASE_URL + heading_image?.url
                : undefined
            }
            alt={"event_image"}
          />
        ) : (
          <div></div>
        )
        //  <div className="bg-gray-200 rounded-xl w-[309px] h-[178px]"></div>
      }
    </div>
  );
};

export default EventHeader;
